import type { FC } from 'react';
import { useEffect } from 'react';
import { toast } from 'sonner';
import type { ReverseAuctionActivity } from 'src/apis/monolith/types';
import type { ActivitiesRequest } from 'src/apis/monolith/use-activities';
import { useWithdrawBid } from 'src/apis/monolith/use-withdraw-bid';
import { Modal } from 'src/components/overlay/modal';
import type { Successful } from 'src/hooks/use-axios';

type Props = {
  close: () => void;
  activity: ReverseAuctionActivity;
  activities: Successful<ActivitiesRequest>;
};

export const WithdrawBidOnReverseAuctionModal: FC<Props> = ({
  close,
  activity,
  activities,
}) => {
  const withdrawBid = useWithdrawBid();

  useEffect(() => {
    if (!withdrawBid.response) return;
    close();
    activities.refresh?.();
    // oxlint-disable-next-line exhaustive-deps
  }, [withdrawBid.response]);

  useEffect(() => {
    if (withdrawBid.response) toast.success('Bid withdrawn successfully.');
    // oxlint-disable-next-line exhaustive-deps
  }, [withdrawBid.response]);

  return (
    <Modal
      title="Withdraw Bid"
      onDismiss={close}
      footer={{
        confirmButton: {
          label: withdrawBid.pending ? 'Pending...' : 'Withdraw Bid',
          dataTestId: 'confirm-withdraw-bid',
          disabled: withdrawBid.pending,
          onClick: () => withdrawBid.execute({ orderId: activity.orderId }),
        },
      }}
    >
      <p>
        Please, confirm that you want to withdraw the bid on Reverse Auction ID{' '}
        {activity.auctionId}.
      </p>
    </Modal>
  );
};
